import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Section from './Section'
import SectionTitle from './SectionTitle'

const API_FEATURE_IDS = [
  'marketing.api.feature.openapi',
  'marketing.api.feature.keys',
  'marketing.api.feature.json',
  'marketing.api.feature.webhooks',
]

const ApiSection: React.FC = () => {
  const intl = useIntl()
  return (
    <Section>
      <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
        <div>
          <SectionTitle
            title={intl.formatMessage({ id: 'marketing.api.title' })}
            subtitle={intl.formatMessage({ id: 'marketing.api.subtitle' })}
            centered={false}
            className="mb-6"
          />
          <ul className="space-y-3">
            {API_FEATURE_IDS.map((id, i) => (
              <li key={i} className="flex items-center gap-2 text-sm text-foreground-muted">
                <svg className="h-4 w-4 text-secondary flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <FormattedMessage id={id} />
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 lg:mt-0">
          <div className="bg-gray-900 rounded-xl p-4 sm:p-6 shadow-lg overflow-x-auto">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-3 w-3 rounded-full bg-red-500" />
              <div className="h-3 w-3 rounded-full bg-yellow-500" />
              <div className="h-3 w-3 rounded-full bg-green-500" />
              <span className="ml-2 text-xs text-gray-400 font-mono"><FormattedMessage id="marketing.api.terminal" /></span>
            </div>
            <pre className="text-xs sm:text-sm text-green-400 font-mono whitespace-pre-wrap break-all sm:break-normal leading-relaxed">
              {intl.formatMessage({ id: 'marketing.api.codeExample' })}
            </pre>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ApiSection
